import { BrowserRouter as Router, Switch } from "react-router-dom";
import Layout from "./components/layout/Layout";
import GeustRoute from "./helpers/authentication/geustRoute";
import Login from "./views/authentication/Login";
import Home from "./views/Home";
import AuthRoute from "./helpers/authentication/authRoute";
import ModeratorsIndex from "./views/moderators/ModeratorsIndex";
import ModeratorsCreate from "./views/moderators/ModeratorsCreate";
import ModeratorShow from "./views/moderators/ModeratorShow";
import RolesIndex from "./views/roles/RolesIndex";
import RolesCreate from "./views/roles/RolesCreate";
import RolesShow from "./views/roles/RolesShow";
import BlogIndex from "./views/blog/BlogIndex";
import BlogCreate from "./views/blog/BlogCreate";
import BlogShow from "./views/blog/BlogShow";
import CategoriesIndex from "./views/blog/categories/CategoriesIndex";
import CategoriesCreate from "./views/blog/categories/CategoriesCreate";
import CategoriesShow from "./views/blog/categories/CategoriesShow";
import PagesIndex from "./views/pages/PagesIndex";
import PagesCreate from "./views/pages/PagesCreate";
import PagesShow from "./views/pages/PagesShow";
import ContactIndex from "./views/contact/ContactIndex";
import ContactShow from "./views/contact/ContactShow";
import ReasonsIndex from "./views/careers/reasons/ReasonsIndex";
import ReasonsCreate from "./views/careers/reasons/ReasonsCreate";
import ReasonsShow from "./views/careers/reasons/ReasonsShow";
import PositionsIndex from "./views/careers/positions/PositionsIndex";
import PositionsCreate from "./views/careers/positions/PositionsCreate";
import PositionsShow from "./views/careers/positions/PositionsShow";
import CareersApplications from "./views/careers/CareersApplications";
import ServicesIndex from "./views/services/ServicesIndex";
import ServicesCreate from "./views/services/ServicesCreate";
import ServiceShow from "./views/services/ServiceShow";
import ServicesApplications from "./views/services/ServicesApplications";
import ServiceShowApplication from "./views/services/ServiceShowApplication";
import WorksIndex from "./views/works/WorksIndex";
import WorksCreate from "./views/works/WorksCreate";
import WorkShow from "./views/works/WorkShow";
import SectionsIndex from "./views/works/sections/SectionsIndex";
import SectionsCreate from "./views/works/sections/SectionsCreate";
import SectionsShow from "./views/works/sections/SectionsShow";
import FaqIndex from "./views/faq/FaqIndex";
import FaqCreate from "./views/faq/FaqCreate";
import FaqShow from "./views/faq/FaqShow";
import EmployeesIndex from "./views/employees/EmployeesIndex";
import EmployeesCreate from "./views/employees/EmployeesCreate";
import EmployeesShow from "./views/employees/EmployeesShow";
import PackagesIndex from "./views/packages/PackagesIndex";
import PackagesCreate from "./views/packages/PackagesCreate";
import PackagesShow from "./views/packages/PackagesShow";
import PartnersIndex from "./views/partners/PartnersIndex";
import PartnersCreate from "./views/partners/PartnersCreate";
import PartnersShow from "./views/partners/PartnersShow";
import OpinionsIndex from "./views/opinions/OpinionsIndex";
import OpinionsCreate from "./views/opinions/OpinionsCreate";
import OpinionsShow from "./views/opinions/OpinionsShow";
import AboutShow from "./views/AboutShow";
import Subscribers from "./views/newsletter/Subscribers";
import Email from "./views/newsletter/Email";
import Settings from "./views/Settings";
import Menu from "./views/Menu";
import Offers from "./views/Offers";
import CoastsIndex from "./views/services/coasts/CoastsIndex";
import CoastsCreate from "./views/services/coasts/CoastsCreate";
import CoastsShow from "./views/services/coasts/CoastsShow";
import IntroIndex from "./views/intro/IntroIndex";
import IntroCreate from "./views/intro/IntroCreate";
import IntroShow from "./views/intro/IntroShow";
import MailIndex from "./views/MailIndex";
import SEORedirects from "./views/SEORedirects";
import EditSeoRedirect from "./views/SEORedirects/Edit";
import AddSeoRedirect from "./views/SEORedirects/Add";
import HeroShow from "./views/hero/HeroShow";

import SeoIndex from "./views/seo/Index";
import CreateSeo from "./views/seo/Create";
import EditSeo from "./views/seo/Edit";

function App() {
	return (
		<Router>
			<Switch>
				<GeustRoute path="/login" component={Login} />
				<Layout>
					<AuthRoute path="/" exact component={Home} />
					<AuthRoute path="/dashboard" component={Home} />
					{/*/!*moderators*!/*/}
					<AuthRoute path="/moderators/index" component={ModeratorsIndex} />
					<AuthRoute path="/moderators/create" component={ModeratorsCreate} />
					<AuthRoute
						path="/moderators/show/:moderatorID"
						component={ModeratorShow}
					/>
					{/*roles*/}
					<AuthRoute path="/roles/index" component={RolesIndex} />
					<AuthRoute path="/roles/create" component={RolesCreate} />
					<AuthRoute path="/roles/show/:roleID" component={RolesShow} />
					{/*blog*/}
					<AuthRoute path="/blog/index" component={BlogIndex} />
					<AuthRoute path="/blog/create" component={BlogCreate} />
					<AuthRoute path="/blog/show/:blogID" component={BlogShow} />
					<AuthRoute path="/categories/index" component={CategoriesIndex} />
					<AuthRoute path="/categories/create" component={CategoriesCreate} />
					<AuthRoute
						path="/categories/show/:categoryID"
						component={CategoriesShow}
					/>
					{/*pages*/}
					<AuthRoute path="/pages/index" component={PagesIndex} />
					<AuthRoute path="/pages/create" component={PagesCreate} />
					<AuthRoute path="/pages/show/:pageID" component={PagesShow} />
					{/*contact*/}
					<AuthRoute path="/contact/index" component={ContactIndex} />
					<AuthRoute path="/contact/show/:contactID" component={ContactShow} />
					{/*careers*/}
					<AuthRoute path="/reasons/index" component={ReasonsIndex} />
					<AuthRoute path="/reasons/create" component={ReasonsCreate} />
					<AuthRoute path="/reasons/show/:reasonID" component={ReasonsShow} />
					<AuthRoute path="/positions/index" component={PositionsIndex} />
					<AuthRoute path="/positions/create" component={PositionsCreate} />
					<AuthRoute
						path="/positions/show/:positionID"
						component={PositionsShow}
					/>
					<AuthRoute
						path="/careers/applications"
						component={CareersApplications}
					/>
					{/*services*/}
					<AuthRoute path="/services/index" component={ServicesIndex} />
					<AuthRoute path="/services/create" component={ServicesCreate} />
					<AuthRoute path="/services/show/:serviceID" component={ServiceShow} />
					<AuthRoute
						path="/services/applications"
						component={ServicesApplications}
					/>
					<AuthRoute
						path="/services/application/:applicationID"
						component={ServiceShowApplication}
					/>
					<AuthRoute path="/coasts/index" component={CoastsIndex} />
					<AuthRoute path="/coasts/create" component={CoastsCreate} />
					<AuthRoute path="/coasts/show/:coastID" component={CoastsShow} />
					{/*works*/}
					<AuthRoute path="/works/index" component={WorksIndex} />
					<AuthRoute path="/works/create" component={WorksCreate} />
					<AuthRoute path="/works/show/:workID" component={WorkShow} />
					<AuthRoute path="/sections/index" component={SectionsIndex} />
					<AuthRoute path="/sections/create" component={SectionsCreate} />
					<AuthRoute
						path="/sections/show/:sectionID"
						component={SectionsShow}
					/>
					{/*faq*/}
					<AuthRoute path="/faq/index" component={FaqIndex} />
					<AuthRoute path="/faq/create" component={FaqCreate} />
					<AuthRoute path="/faq/show/:faqID" component={FaqShow} />
					{/*employees*/}
					<AuthRoute path="/employees/index" component={EmployeesIndex} />
					<AuthRoute path="/employees/create" component={EmployeesCreate} />
					<AuthRoute
						path="/employees/show/:employeesID"
						component={EmployeesShow}
					/>
					{/*packages*/}
					<AuthRoute path="/packages/index" component={PackagesIndex} />
					<AuthRoute path="/packages/create" component={PackagesCreate} />
					<AuthRoute
						path="/packages/show/:packageID"
						component={PackagesShow}
					/>
					{/*partners*/}
					<AuthRoute path="/partners/index" component={PartnersIndex} />
					<AuthRoute path="/partners/create" component={PartnersCreate} />
					<AuthRoute
						path="/partners/show/:partnerID"
						component={PartnersShow}
					/>
					{/*opinions*/}
					<AuthRoute path="/opinions/index" component={OpinionsIndex} />
					<AuthRoute path="/opinions/create" component={OpinionsCreate} />
					<AuthRoute
						path="/opinions/show/:opinionID"
						component={OpinionsShow}
					/>
					{/*about*/}
					<AuthRoute path="/about/show" component={AboutShow} />
					{/*newsletter*/}
					<AuthRoute path="/subscribers" component={Subscribers} />
					<AuthRoute path="/email" component={Email} />
					{/*settings*/}
					<AuthRoute path="/settings" component={Settings} />
					<AuthRoute path="/menu" component={Menu} />
					{/*offers*/}
					<AuthRoute path="/offers" component={Offers} />
					{/*employees*/}
					<AuthRoute path="/intro/index" component={IntroIndex} />
					<AuthRoute path="/intro/create" component={IntroCreate}></AuthRoute>
					<AuthRoute path="/intro/show/:introID" component={IntroShow} />
					{/*generalMail*/}
					<AuthRoute path="/mail/index" component={MailIndex} />
					{/*hero*/}
					<AuthRoute path="/hero" component={HeroShow} />
					{/* ------ */}
					<AuthRoute exact path="/seoRedirects" component={SEORedirects} />
					<AuthRoute
						path="/seoRedirects/addSeoRedirects"
						component={AddSeoRedirect}
					/>
					<AuthRoute
						path="/seoRedirects/editSeoRedirects/:id"
						component={EditSeoRedirect}
					/>
					<AuthRoute path="/seo/index" component={SeoIndex} />
					<AuthRoute path="/seo/create" component={CreateSeo} />
					<AuthRoute path="/seo/show/:id" component={EditSeo} />
				</Layout>
			</Switch>
		</Router>
	);
}

export default App;
